import { ThemeContext } from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import { Link } from 'gatsby';
import React, { useContext } from 'react';

import * as styles from './Button.module.css';

const Button = ({
	children,
	to,
	size = 'md',
	theme = undefined,
	disabled = false,
	download,
	type,
	onClick,
	className = '',
	pseudoFill = false,
}: {
	children: React.ReactNode;
	to?: string;
	size?: 'md' | 'lg' | 'xl';
	theme?:
		| 'inverted'
		| 'ghost'
		| 'inline'
		| 'reversed'
		| 'lightblue'
		| undefined;
	disabled?: boolean;
	download?: boolean;
	type?: 'submit' | 'reset';
	onClick?: any;
	className?: string;
	pseudoFill?: boolean;
}) => {
	const { variant } = useContext(ThemeContext);
	const internal = /^\/(?!\/)/.test(to);

	const hasSvg = Array.isArray(children)
		? children
				.map((item) => typeof item === 'object')
				.some((item) => item === true)
		: null;

	return (
		<>
			{to ? (
				internal && !download ? (
					<Link
						to={to}
						disabled={disabled}
						onClick={onClick}
						className={cx(
							styles.button,
							styles[`${size}Size`],
							styles[theme],
							styles[variant],
							className,
							{
								[styles['hasSvg']]: hasSvg,
								[styles['pseudoFill']]: pseudoFill,
							}
						)}>
						{children}
					</Link>
				) : (
					<a
						href={to}
						disabled={disabled}
						download={download}
						target={download ? '_self' : '_blank'}
						onClick={onClick}
						className={cx(
							styles.button,
							styles[`${size}Size`],
							styles[theme],
							styles[variant],
							className,
							{
								[styles['hasSvg']]: hasSvg,
								[styles['pseudoFill']]: pseudoFill,
							}
						)}>
						{children}
					</a>
				)
			) : (
				<button
					className={cx(
						styles.button,
						styles[`${size}Size`],
						styles[theme],
						className,
						styles[variant],
						{
							[styles['hasSvg']]: hasSvg,
						}
					)}
					type={type}
					onClick={onClick}>
					{children}
				</button>
			)}
		</>
	);
};

export default Button;
